export const UPDATE_NEWS = "UPDATE_NEWS";

export const updateNews = (value) => ({
  type: UPDATE_NEWS,
  value,
});
